import React, { useEffect, useState } from 'react';
import drawerHoc from '../../../../../components/drawerHOC/DrawerHOC';

import CustomText from "./../../../../../components/text/TextComponent"
import { Ionicons } from '@expo/vector-icons';
import { Entypo } from '@expo/vector-icons';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { TextInput } from '../../atoms/textinput';
import { View, Text, Image, TouchableOpacity, TextInput as RNTextInput, ScrollView, StyleSheet, useWindowDimensions } from 'react-native';
import Checkbox from '@material-ui/core/Checkbox';
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from '@stripe/stripe-js/pure';
import { EmailValidation, NameValidation, MobileValidation } from "../../../../../helpers/validation";
import { validateNumericWithSpaces } from "../../../../../helpers/helpers";
import { AntDesign, MaterialCommunityIcons, Feather } from '@expo/vector-icons';
import CheckoutForm from './checkoutForm';

import { useRoute } from '@react-navigation/native';
import { showErrorToast } from '../../helpers';
import Urls from '../../../../../services/Urls';
import ajax from '../../../../../helpers/ajaxHelper';
import logo from '../../../../../assets/images/safe2logo.png';
import { goBack } from '../../../../../navigation/RootNavigation';
import Loader from '../../../../../components/loader';
import { SHADOWS } from '../../../../../constants/theme';


var curr = new Date();
curr.setDate(curr.getDate() + 10);
var mindate = curr.toISOString().substring(0, 10);

let initialValues = {
    gas_type: 'Natural',
    key_pick_up: '',
    key_drop_off: '',
    Furnishing: '',
};
const STRIPEKEY = 'pk_live_51MlCEgFCJVtBrQ2WrFpZjfEbieiBD6GaxyoY5mQsOe7Sxfkj6qHvaIMxEshrwCvNnjqV2IJ2SoE0xs8ip6DVlRnc00l6X5Hl3u';

const stripePromise = loadStripe(STRIPEKEY);

const webSelectInput = {
    width: '100%',
    height: '42px',
    borderWidth: 0,
    backgroundColor: 'white',
    borderRadius: '8px',
};

const webInputWrapper = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    marginTop: '4px',
    marginBottom: '8px',
};

const CommanBuyCertificate = ({ navigation }) => {

    const [pageInfo, updatePageInfo] = React.useState('');
    const [pageType, updatePageType] = React.useState(null);
    const [fieldsValue, setFieldValues] = React.useState(initialValues);
    const [checkForError, setCheckForError] = React.useState(false);
    const [page, setPage] = React.useState(1);
    const route = useRoute();
    const [bed, setBed] = React.useState(1);
    const [totalCost, setTotalCost] = React.useState(0);
    const [minValue, setMinValue] = React.useState(1);
    const [ispoa, setIsPoa] = React.useState(false);
    const [clientSecret, setClientSecret] = React.useState('');
    const [loading, setLoading] = useState(false);
    const { width } = useWindowDimensions();
    const isMobile = width <= 768;
    const isTablet = width > 768 && width <= 1024;

    useEffect(() => {
        updatePageType(route?.params?.pageType);
        setMinValue(1)
        setFieldValues(initialValues)
    }, [route?.params?.pageType])

    useEffect(() => {
        if (pageType === 'gas_certificate') {
            updatePageInfo('Gas Safety Certificate (CP12)')
            setTotalCost(65)
        }
        else if (pageType === 'epc_certificate') {
            updatePageInfo('Energy Performance Certificate (EPC)')
            setTotalCost(65)
        }
        else if (pageType === 'pat') {
            updatePageInfo('Portable Appliance Testing (PAT)')
            setTotalCost(50)
        }
        else {
            updatePageInfo('Electrical Installation Condition Report (EICR)')
            setTotalCost(130)
        }
    }, [pageType])

    useEffect(() => {
        if (pageType === 'gas_certificate') {
            if (minValue == 1) {
                if (fieldsValue.gas_type === "LPG") {
                    setTotalCost(85)
                } else {
                    setTotalCost(65)
                }
            }
            if (minValue == 2) {
                if (fieldsValue.gas_type === "LPG") {
                    setTotalCost(85)
                } else {
                    setTotalCost(65)
                }
            }
            if (minValue == 3) {
                if (fieldsValue.gas_type === "LPG") {
                    setTotalCost(105)
                } else {
                    setTotalCost(85)
                }
            }
            if (minValue == 4) {
                if (fieldsValue.gas_type === "LPG") {
                    setTotalCost(115)
                } else {
                    setTotalCost(95)
                }
            }
            if (minValue == 5) {
                if (fieldsValue.gas_type === "LPG") {
                    setTotalCost(145)
                } else {
                    setTotalCost(125)
                }
            }
            if (minValue > 6) {
                setTotalCost("N/A")
            }
        }
        else if (pageType === 'epc_certificate') {
            if (minValue > 0 && minValue < 5) {
                setTotalCost(65)
            } else if (minValue > 4 && minValue < 7) {
                setTotalCost(75)
            }
            if (minValue > 6) {
                setTotalCost("N/A")
            }
        }
        else {
            if (minValue == 1) {
                setTotalCost(130)
            }
            if (minValue == 2) {
                setTotalCost(140)
            }
            if (minValue == 3) {
                setTotalCost(150)
            }
            if (minValue == 4) {
                setTotalCost(160)
            }
            if (minValue == 5) {
                setTotalCost(170)
            }
            if (minValue > 5) {
                setTotalCost("N/A")
            }
        }

    }, [minValue, fieldsValue.gas_type])


    const _onNext = () => {
        const requestBody = fieldsValue
        requestBody.certificate_name = pageType
        requestBody.property_id = route?.params?.property_id
        requestBody.confirmDateCheckbox = confirmDateCheckbox
        requestBody.notifyDateCheckbox = notifyDateCheckbox
        requestBody.price = totalCost
        requestBody.totalPrice = totalCost + totalCost * 0.20,
        requestBody.amount = totalCost + totalCost * 0.20
        if (pageType === 'gas_certificate') {
            requestBody.number_of_appliances = minValue
        }
        else {
            requestBody.number_of_bedrooms = minValue
        }

        console.log("requestBodyyyyyyyyyyyyy", requestBody)
        ajax
            .post(Urls.CERTIFICATE_PAYMENTS, requestBody)
            .then(({ data }) => {
                if (data.status) {
                    console.log('data: 166============', data, data?.data?.data?.clientSecret);
                    setClientSecret(data?.data?.data?.clientSecret)
                }
                setPage(2)
            })
            .catch((error) => {
                console.log('error', error);
            });
    }

    const checkValues = () => {

        if (fieldsValue?.agent_email && fieldsValue?.name && fieldsValue?.contact && fieldsValue?.agent_contact && fieldsValue?.conduct_date && fieldsValue?.Furnishing && fieldsValue?.key_pick_up && fieldsValue?.key_drop_off) {
            setCheckForError(false)
            let EmailValidate = EmailValidation(fieldsValue?.agent_email);
            let FSValidate = NameValidation(fieldsValue?.name);
            let ContactValidate = MobileValidation(fieldsValue?.contact);
            let AgentValidate = MobileValidation(fieldsValue?.agent_contact);
            if (

                EmailValidate.status &&
                FSValidate.status &&
                ContactValidate.status &&
                AgentValidate.status
            ) {
                _onNext();

            }
        } else {
            setCheckForError(true)
            showErrorToast("Please complete the mandatory fields!")
        }
    }

    const handleChange = (e, name) => {
        if (e.target.name === "agent_contact" || e.target.name === "contact") {
            setFieldValues({ ...fieldsValue, [e.target.name]: validateNumericWithSpaces(e.target.value) });
        }
        else {
            setFieldValues({ ...fieldsValue, [e.target.name]: e.target.value });

        }
    };
    const [confirmDateCheckbox, setConfirmDateCheckbox] = React.useState(false);
    const [notifyDateCheckbox, setNotifyDateCheckbox] = React.useState(false);
    console.log("fieldsValuefieldsValue", fieldsValue)
    const checkForErrorFunct = (feildName, type) => {
        if (checkForError) {
            if (feildName) {
                if (type == "email") {
                    console.log("EmailValidation(feildName)", EmailValidation(feildName))
                    if (EmailValidation(feildName).status) {
                        return null
                    } else {
                        return "Email is invalid!"
                    }
                } else {
                    return null
                }
            } else {
                return "Field is mandatory!"
            }
        } else {
            return null
        }

    }

    const addAndSubtractValue = (value, type) => {
        if (type == "ADD") {
            setMinValue(minValue + 1)
        } else {
            setMinValue(minValue - 1)
        }
    }

    /* ── Helper: get page icon name ── */
    const getPageIcon = () => {
        if (pageType === 'gas_certificate') return 'fire';
        if (pageType === 'epc_certificate') return 'lightning-bolt';
        if (pageType === 'pat') return 'power-plug-outline';
        return 'flash-circle';
    };

    /* ── Error text component ── */
    const ErrorText = ({ error }) => {
        if (!error) return null;
        return <Text style={s.errorText}>{error}</Text>;
    };

    /* ── Inline Text for checkout form areas needing custom props ── */
    const CT = CustomText;

    /* ═══════════════════════════════════════════
       RENDER: HEADER (Breadcrumb + Banner Card)
    ═══════════════════════════════════════════ */
    const renderHeader = () => {
        return (
            <View style={{ paddingHorizontal: isMobile ? 16 : 24 }}>
                {/* Breadcrumb */}
                <View style={s.breadcrumbBar}>
                    <TouchableOpacity onPress={() => navigation.goBack()} style={s.backBtn}>
                        <AntDesign name="left" size={12} color="#6C2BD9" />
                        <Text style={s.backText}>Back</Text>
                    </TouchableOpacity>
                    <Text style={s.breadSep}>Certification</Text>
                    <Text style={s.breadSep}>{'>'}</Text>
                    <Text style={[s.breadSep, { color: '#111827', fontWeight: '600' }]}>Purchase Certificate</Text>
                </View>

                {/* Banner Card */}
                <View style={[s.bannerCard, isMobile && s.bannerCardMobile]}>
                    <View style={s.bannerLeft}>
                        <View style={s.bannerIconWrap}>
                            <MaterialCommunityIcons name={getPageIcon()} size={22} color="#6C2BD9" />
                        </View>
                        <View style={s.bannerTextWrap}>
                            <Text style={s.bannerTitle}>{pageInfo}</Text>
                            <Text style={s.bannerSubtitle}>
                                Complete the details below to purchase your certificate
                            </Text>
                        </View>
                    </View>
                    <View style={s.poweredByWrap}>
                        <Text style={s.poweredByText}>Powered by</Text>
                        <Image
                            style={{ width: 50, height: 50 }}
                            source={logo}
                            resizeMode='contain'
                        />
                    </View>
                </View>
            </View>
        )
    }

    /* ═══════════════════════════════════════════
       RENDER: FORM CONTENT (Page 1)
    ═══════════════════════════════════════════ */
    const renderContent = () => {
        return (
            <View style={[s.contentRow, isMobile && s.contentRowMobile]}>
                {/* LEFT CARD: Cost & Details */}
                <View style={[s.formCard, !isMobile && { flex: 1 }]}>
                    {/* Cost Row */}
                    <View style={s.costRow}>
                        <Text style={s.costLabel}>Cost:</Text>
                        <View style={s.costPill}>
                            <Text style={s.costValue}>
                                {totalCost == "N/A" ? null : "£ "}{totalCost}
                            </Text>
                        </View>
                        <Text style={s.costVat}>+VAT</Text>
                    </View>

                    {/* Appliances / Bedrooms counter */}
                    {pageType === "gas_certificate" ?
                        <>
                            <Text style={[s.sectionLabel, { marginTop: 20 }]}>Number of appliances:</Text>
                            <Text style={s.sectionHint}>eg boiler, boiler and cooker, boiler, hob and fire</Text>
                        </> :
                        <Text style={[s.sectionLabel, { marginTop: 20 }]}>Number of bed rooms:</Text>
                    }

                    <View style={s.counterRow}>
                        <TouchableOpacity
                            disabled={minValue == 1}
                            onPress={() => addAndSubtractValue(1, "SUB")}
                            style={[s.counterBtn, minValue == 1 && s.counterBtnDisabled]}
                        >
                            <Entypo name="minus" size={18} color="white" />
                        </TouchableOpacity>

                        <View style={s.counterDisplay}>
                            <Text style={s.counterValue}>{minValue}</Text>
                        </View>

                        <TouchableOpacity
                            onPress={() => addAndSubtractValue(1, "ADD")}
                            style={s.counterBtn}
                        >
                            <Ionicons name="add" size={18} color="white" />
                        </TouchableOpacity>
                    </View>

                    {/* Gas Type (gas only) */}
                    {pageType === "gas_certificate" ? <>
                        <Text style={[s.fieldLabel, { marginTop: 20 }]}>Gas Type</Text>
                        <Select
                            value={fieldsValue?.gas_type}
                            style={webSelectInput}
                            onChange={handleChange}
                            variant="outlined"
                            name="gas_type"
                            placeholder="Select Gas Type"
                        >
                            <MenuItem value={'Natural'}>Natural</MenuItem>
                            <MenuItem value={'LPG'}>LPG + £20</MenuItem>
                        </Select>
                        <ErrorText error={checkForErrorFunct(fieldsValue?.gas_type)} />
                    </> : null}

                    {/* Conduct Date */}
                    <Text style={[s.fieldLabel, { marginTop: 20 }]}>Conduct Date</Text>
                    <TextInput
                        title={<></>}
                        type={'date'}
                        wrapperstyle={webInputWrapper}
                        inputTextStyle={{ marginBottom: 0 }}
                        containerstyles={{ width: '100%' }}
                        value={fieldsValue?.conduct_date}
                        name="conduct_date"
                        onChange={handleChange}
                        inputProps={{ min: mindate }}
                        error={checkForErrorFunct(fieldsValue?.conduct_date)}
                    />

                    {/* Access Details */}
                    <View style={s.divider} />
                    <Text style={s.sectionTitle}>Access Details</Text>

                    <Text style={s.fieldLabel}>Name</Text>
                    <TextInput
                        title={""}
                        type={'column'}
                        wrapperstyle={webInputWrapper}
                        inputTextStyle={{ marginBottom: 0 }}
                        containerstyles={{ width: '100%' }}
                        value={fieldsValue?.name}
                        error={checkForErrorFunct(fieldsValue?.name)}
                        name="name"
                        onChange={handleChange}
                    />

                    <Text style={s.fieldLabel}>Contact No</Text>
                    <TextInput
                        title={""}
                        type={'column'}
                        wrapperstyle={webInputWrapper}
                        inputTextStyle={{ marginBottom: 0 }}
                        containerstyles={{ width: '100%' }}
                        value={fieldsValue?.contact}
                        name="contact"
                        onChange={handleChange}
                        error={checkForErrorFunct(fieldsValue?.contact)}
                    />

                    <Text style={[s.fieldLabel, { marginTop: 12 }]}>Furnishing</Text>
                    <Select
                        value={fieldsValue?.Furnishing}
                        style={webSelectInput}
                        onChange={handleChange}
                        variant="outlined"
                        name="Furnishing"
                        placeholder="Furnishing"
                    >
                        <MenuItem value={'Fully Furnished'}>Furnished</MenuItem>
                        <MenuItem value={'Part Furnished'}>Part Furnished</MenuItem>
                        <MenuItem value={'Unfurnished'}>UnFurnished</MenuItem>
                    </Select>
                    <ErrorText error={checkForErrorFunct(fieldsValue?.Furnishing)} />
                </View>

                {/* RIGHT CARD: Key Info & Landlord Details */}
                <View style={[s.formCard, !isMobile && { flex: 1 }]}>
                    <Text style={s.sectionTitle}>Key Pick Up Information</Text>
                    <Text style={s.sectionHint}>Where are the keys to be picked up?</Text>

                    <Text style={[s.fieldLabel, { marginTop: 16 }]}>Key Pick Up</Text>
                    <Select
                        value={fieldsValue?.key_pick_up}
                        style={webSelectInput}
                        onChange={handleChange}
                        variant="outlined"
                        name="key_pick_up"
                        placeholder="key_pick_up"
                    >
                        <MenuItem value={'Occupied - Knock/Ring Door'}>Occupied - Knock/Ring Door</MenuItem>
                        <MenuItem value={'Collect from Agent'}>Collect from Agent</MenuItem>
                        <MenuItem value={'Collect from Neighbour'}>Collect from Neighbour</MenuItem>
                        <MenuItem value={'Collect from Lockbox'}>Collect from Lockbox</MenuItem>
                        <MenuItem value={'Other'}>Other</MenuItem>
                    </Select>
                    <ErrorText error={checkForErrorFunct(fieldsValue?.key_pick_up)} />

                    <Text style={[s.fieldLabel, { marginTop: 12 }]}>Notes</Text>
                    <View style={s.textAreaWrap}>
                        <RNTextInput
                            style={s.textArea}
                            multiline={true}
                            maxLength={500}
                            placeholder={'Enter pick up details'}
                            onChangeText={(val) => handleChange({ target: { name: "key_pick_up_address", value: val } })}
                            id={'key_pick_up_address'}
                            value={fieldsValue?.key_pick_up_address}
                        />
                    </View>
                    {fieldsValue?.key_pick_up_address ?
                        <Text style={s.charLeft}>
                            {500 - fieldsValue?.key_pick_up_address.length} characters left
                        </Text> : null}

                    <Text style={[s.fieldLabel, { marginTop: 16 }]}>Key Drop Off</Text>
                    <Select
                        value={fieldsValue?.key_drop_off}
                        style={webSelectInput}
                        onChange={handleChange}
                        variant="outlined"
                        name="key_drop_off"
                        placeholder="Select Option"
                    >
                        <MenuItem value={'Not Required'}>Not Required</MenuItem>
                        <MenuItem value={'Return to Agent'}>Return to Agent</MenuItem>
                        <MenuItem value={'Post through letterbox'}>Post through letterbox</MenuItem>
                        <MenuItem value={'Return to Neighbour'}>Return to Neighbour</MenuItem>
                        <MenuItem value={'Return to Lockbox'}>Return to Lockbox</MenuItem>
                        <MenuItem value={'Retain until further instruction'}>Retain until further instruction</MenuItem>
                        <MenuItem value={'Other'}>Other</MenuItem>
                    </Select>
                    <ErrorText error={checkForErrorFunct(fieldsValue?.key_drop_off)} />

                    <Text style={[s.fieldLabel, { marginTop: 12 }]}>Notes</Text>
                    <View style={s.textAreaWrap}>
                        <RNTextInput
                            style={s.textArea}
                            multiline={true}
                            maxLength={500}
                            placeholder={'Enter drop off address'}
                            onChangeText={(val) => handleChange({ target: { name: "key_drop_off_address", value: val } })}
                            id={'key_drop_off_address'}
                            value={fieldsValue?.key_drop_off_address}
                        />
                    </View>
                    {fieldsValue?.key_drop_off_address ?
                        <Text style={s.charLeft}>
                            {500 - fieldsValue?.key_drop_off_address.length} characters left
                        </Text> : null}

                    {/* Landlord Details */}
                    <View style={s.divider} />
                    <Text style={s.sectionTitle}>Landlord Details</Text>

                    <Text style={s.fieldLabel}>Contact No.</Text>
                    <TextInput
                        title={""}
                        type={'column'}
                        wrapperstyle={webInputWrapper}
                        inputTextStyle={{ marginBottom: 0 }}
                        containerstyles={{ width: '100%' }}
                        value={fieldsValue?.agent_contact}
                        name="agent_contact"
                        onChange={handleChange}
                        error={checkForErrorFunct(fieldsValue?.agent_contact)}
                    />

                    <Text style={s.fieldLabel}>Email</Text>
                    <TextInput
                        title={""}
                        type={'column'}
                        wrapperstyle={webInputWrapper}
                        inputTextStyle={{ marginBottom: 0 }}
                        containerstyles={{ width: '100%' }}
                        value={fieldsValue?.agent_email}
                        name="agent_email"
                        onChange={handleChange}
                        error={checkForErrorFunct(fieldsValue?.agent_email, "email")}
                    />

                    <Text style={[s.fieldLabel, { marginTop: 12 }]}>Notes</Text>
                    <View style={s.textAreaWrap}>
                        <RNTextInput
                            style={s.textArea}
                            multiline={true}
                            maxLength={500}
                            placeholder={'Enter notes'}
                            onChangeText={(val) => handleChange({ target: { name: "notes", value: val } })}
                            id={'notes'}
                            value={fieldsValue?.notes}
                        />
                    </View>
                    {fieldsValue?.notes ?
                        <Text style={s.charLeft}>
                            {500 - fieldsValue?.notes.length} characters left
                        </Text> : null}

                    {/* Checkboxes */}
                    <View style={s.checkboxRow}>
                        <Checkbox
                            name="confirm_date"
                            style={{ color: '#6C2BD9' }}
                            checked={confirmDateCheckbox}
                            onChange={() => setConfirmDateCheckbox(!confirmDateCheckbox)}
                        />
                        <Text style={s.checkboxLabel}>Confirm Date and visit with tenants</Text>
                    </View>

                    <View style={s.checkboxRow}>
                        <Checkbox
                            name="notify_date"
                            style={{ color: '#6C2BD9' }}
                            checked={notifyDateCheckbox}
                            onChange={() => setNotifyDateCheckbox(!notifyDateCheckbox)}
                        />
                        <Text style={s.checkboxLabel}>Notify Date and visit with tenants</Text>
                    </View>

                    {/* Action Buttons */}
                    <View style={s.actionRow}>
                        <TouchableOpacity style={s.cancelBtn} onPress={() => goBack()} activeOpacity={0.8}>
                            <Text style={s.cancelBtnText}>Cancel</Text>
                        </TouchableOpacity>
                        {totalCost === "N/A" ? null :
                            <TouchableOpacity style={s.nextBtn} onPress={() => checkValues()} activeOpacity={0.8}>
                                <Text style={s.nextBtnText}>Next →</Text>
                            </TouchableOpacity>
                        }
                    </View>

                    {totalCost === "N/A" ?
                        <View style={s.naCard}>
                            <Text style={s.naText}>
                                This purchase is currently not available.
                                Please contact <Text style={{ color: '#6C2BD9', textDecorationLine: 'underline' }}>sales@hubita.co.uk</Text> for more info.
                            </Text>
                        </View> : null}
                </View>
            </View>
        )
    }

    /* ═══════════════════════════════════════════
       RENDER: STRIPE CHECKOUT (Page 2)
    ═══════════════════════════════════════════ */
    const renderStripe = () => {
        return (
            <View style={[s.checkoutCard, isMobile && { width: '100%' }]}>
                <Text style={s.checkoutTitle}>Checkout</Text>

                <View style={s.checkoutSummary}>
                    <View style={s.checkoutSummaryRow}>
                        <Text style={s.checkoutItemName}>{pageInfo}</Text>
                        <Text style={s.checkoutItemPrice}>
                            £{totalCost.toFixed(2)} <Text style={{ fontWeight: '500' }}>+ VAT</Text>
                        </Text>
                    </View>
                    <View style={s.checkoutDivider} />
                    <Text style={s.checkoutTotal}>
                        Total Cost: £{(totalCost + totalCost * 0.20).toFixed(2)}
                    </Text>
                </View>

                <Elements
                    stripe={stripePromise}
                    options={{
                        clientSecret: clientSecret,
                    }}
                >
                    <CheckoutForm
                        onSuccessToken={(successResult) => {
                            if (successResult) {
                                setPage(3);
                            } else {
                                setPage(4);
                            }
                        }}
                        onCancel={() => {
                            setPage(1)
                        }}
                    />
                </Elements>
            </View>
        )
    }

    /* ═══════════════════════════════════════════
       RENDER: SUCCESS (Page 3)
    ═══════════════════════════════════════════ */
    const renderSuccess = () => {
        return (
            <View style={[s.resultCard, isMobile && { width: '100%' }]}>
                <View style={s.resultIconWrap}>
                    <Feather name="check-circle" size={48} color="#10B981" />
                </View>

                <Text style={s.resultTitle}>Payment Successful!</Text>
                <View style={s.resultDivider} />

                <TouchableOpacity
                    onPress={() => {
                        setLoading(true)
                        setTimeout(() => {
                            setLoading(false)
                            navigation.goBack()
                        }, 3000);
                    }}
                    style={s.continueBtn}
                    activeOpacity={0.8}
                >
                    <Text style={s.continueBtnText}>Continue</Text>
                    <AntDesign name="arrowright" size={18} color="#fff" style={{ marginLeft: 8 }} />
                </TouchableOpacity>

                <Text style={s.resultMessage}>
                    Thank you for your payment. Please click continue to start your order.
                </Text>
                <Text style={[s.resultMessage, { marginTop: 8 }]}>
                    You will receive confirmation of this payment via email.
                </Text>
            </View>
        )
    }

    /* ═══════════════════════════════════════════
       RENDER: FAILURE (Page 4)
    ═══════════════════════════════════════════ */
    const renderFailure = () => {
        return (
            <View style={[s.resultCard, isMobile && { width: '100%' }]}>
                <View style={[s.resultIconWrap, { backgroundColor: '#FEE2E2' }]}>
                    <Feather name="x-circle" size={48} color="#EF4444" />
                </View>

                <Text style={[s.resultTitle, { color: '#EF4444' }]}>Payment Failed!</Text>
                <View style={[s.resultDivider, { backgroundColor: '#EF4444' }]} />

                <TouchableOpacity
                    onPress={() => setPage(2)}
                    style={[s.continueBtn, { backgroundColor: '#EF4444' }]}
                    activeOpacity={0.8}
                >
                    <Text style={s.continueBtnText}>Try Again</Text>
                    <AntDesign name="arrowright" size={18} color="#fff" style={{ marginLeft: 8 }} />
                </TouchableOpacity>
            </View>
        )
    }

    /* ═══════════════════════════════════════════
       MAIN RETURN
    ═══════════════════════════════════════════ */
    return (
        <View style={s.root}>
            <Loader loading={loading} />
            <ScrollView
                style={{ flex: 1 }}
                contentContainerStyle={{ paddingBottom: 40 }}
                showsVerticalScrollIndicator={false}
            >
                {renderHeader()}

                {page == 1 ? (
                    <View style={{ paddingHorizontal: isMobile ? 16 : 24 }}>
                        <Text style={s.introText}>
                            In order to facilitate the purchase of your {pageType === 'gas_certificate' ? 'Gas Certification' : pageType === 'epc_certificate' ? 'Energy Certification' : 'Electrical Certificate'}, please enter the details below
                        </Text>
                        {renderContent()}
                    </View>
                ) : null}
                {page == 2 ? <View style={{ paddingHorizontal: isMobile ? 16 : 24, alignItems: 'center' }}>{renderStripe()}</View> : null}
                {page == 3 ? <View style={{ paddingHorizontal: isMobile ? 16 : 24, alignItems: 'center' }}>{renderSuccess()}</View> : null}
                {page == 4 ? <View style={{ paddingHorizontal: isMobile ? 16 : 24, alignItems: 'center' }}>{renderFailure()}</View> : null}
            </ScrollView>
        </View>
    );
};

/* ═══════════════════════════════════════════
   STYLES
═══════════════════════════════════════════ */
const s = StyleSheet.create({
    root: {
        flex: 1,
        backgroundColor: '#F5F7FB',
    },

    /* ── Breadcrumb ── */
    breadcrumbBar: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
        paddingVertical: 14,
        flexWrap: 'wrap',
    },
    backBtn: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 4,
        marginRight: 4,
    },
    backText: {
        fontSize: 13,
        color: '#6C2BD9',
        fontWeight: '600',
    },
    breadSep: {
        fontSize: 13,
        color: '#9CA3AF',
        fontWeight: '500',
    },

    /* ── Banner Card ── */
    bannerCard: {
        backgroundColor: '#FFFFFF',
        borderRadius: 14,
        padding: 16,
        borderWidth: 1,
        borderColor: '#E5E7EB',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 20,
        gap: 12,
        ...SHADOWS.sm,
    },
    bannerCardMobile: {
        flexDirection: 'column',
        alignItems: 'flex-start',
    },
    bannerLeft: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
        flex: 1,
        width: '100%',
    },
    bannerIconWrap: {
        width: 44,
        height: 44,
        borderRadius: 22,
        backgroundColor: '#F5F3FF',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    bannerTextWrap: {
        flex: 1,
        minWidth: 0,
    },
    bannerTitle: {
        fontSize: 16,
        fontWeight: '700',
        color: '#111827',
    },
    bannerSubtitle: {
        fontSize: 12,
        color: '#6B7280',
        marginTop: 2,
    },
    poweredByWrap: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 6,
    },
    poweredByText: {
        fontSize: 11,
        color: '#9CA3AF',
        fontWeight: '500',
    },

    /* ── Intro Text ── */
    introText: {
        fontSize: 14,
        fontWeight: '500',
        color: '#374151',
        marginBottom: 20,
        lineHeight: 21,
    },

    /* ── Content Row ── */
    contentRow: {
        flexDirection: 'row',
        gap: 20,
    },
    contentRowMobile: {
        flexDirection: 'column',
    },

    /* ── Form Card ── */
    formCard: {
        backgroundColor: '#fff',
        borderRadius: 14,
        padding: 20,
        marginBottom: 16,
        ...SHADOWS.md,
    },

    /* ── Cost Row ── */
    costRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 12,
    },
    costLabel: {
        fontSize: 15,
        fontWeight: '600',
        color: '#111827',
    },
    costPill: {
        borderWidth: 1.5,
        borderColor: '#6C2BD9',
        borderRadius: 8,
        paddingHorizontal: 18,
        paddingVertical: 8,
        alignItems: 'center',
        justifyContent: 'center',
    },
    costValue: {
        fontSize: 16,
        fontWeight: '700',
        color: '#6C2BD9',
    },
    costVat: {
        fontSize: 14,
        fontWeight: '500',
        color: '#6B7280',
    },

    /* ── Section labels ── */
    sectionLabel: {
        fontSize: 14,
        fontWeight: '600',
        color: '#111827',
    },
    sectionHint: {
        fontSize: 12,
        color: '#9CA3AF',
        marginTop: 2,
    },
    sectionTitle: {
        fontSize: 15,
        fontWeight: '700',
        color: '#111827',
        marginBottom: 12,
    },

    /* ── Counter ── */
    counterRow: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 16,
        gap: 16,
    },
    counterBtn: {
        height: 36,
        width: 36,
        borderRadius: 18,
        backgroundColor: '#6C2BD9',
        justifyContent: 'center',
        alignItems: 'center',
    },
    counterBtnDisabled: {
        backgroundColor: '#D1D5DB',
    },
    counterDisplay: {
        width: 80,
        height: 40,
        borderRadius: 8,
        borderWidth: 1.5,
        borderColor: '#6C2BD9',
        justifyContent: 'center',
        alignItems: 'center',
    },
    counterValue: {
        fontSize: 18,
        fontWeight: '700',
        color: '#111827',
    },

    /* ── Field Label ── */
    fieldLabel: {
        fontSize: 12,
        fontWeight: '600',
        color: '#374151',
        marginBottom: 6,
        marginTop: 6,
    },

    /* ── Select Input ── */
    selectInput: {
        width: '100%',
        height: 42,
        borderWidth: 0,
        backgroundColor: 'white',
        borderRadius: 8,
    },

    /* ── Input Wrapper ── */
    inputWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
        marginTop: 4,
        marginBottom: 8,
    },

    /* ── Text Area ── */
    textAreaWrap: {
        width: '100%',
        height: 90,
        borderColor: '#D1D5DB',
        borderWidth: 1,
        borderRadius: 8,
        marginTop: 4,
        overflow: 'hidden',
    },
    textArea: {
        height: 90,
        width: '100%',
        padding: 10,
        fontSize: 14,
        color: '#111827',
    },
    charLeft: {
        fontSize: 11,
        color: '#9CA3AF',
        textAlign: 'right',
        marginTop: 4,
    },

    /* ── Error ── */
    errorText: {
        fontSize: 12,
        color: '#EF4444',
        textAlign: 'right',
        marginTop: 4,
    },

    /* ── Divider ── */
    divider: {
        height: 1,
        backgroundColor: '#F3F4F6',
        marginVertical: 20,
    },

    /* ── Checkbox ── */
    checkboxRow: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 12,
    },
    checkboxLabel: {
        fontSize: 13,
        fontWeight: '500',
        color: '#374151',
        marginLeft: 4,
    },

    /* ── Action Buttons ── */
    actionRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        gap: 12,
        marginTop: 24,
    },
    cancelBtn: {
        flex: 1,
        backgroundColor: '#fff',
        borderWidth: 1.5,
        borderColor: '#EF4444',
        borderRadius: 10,
        paddingVertical: 12,
        alignItems: 'center',
    },
    cancelBtnText: {
        fontSize: 14,
        fontWeight: '700',
        color: '#EF4444',
    },
    nextBtn: {
        flex: 1,
        backgroundColor: '#6C2BD9',
        borderRadius: 10,
        paddingVertical: 12,
        alignItems: 'center',
    },
    nextBtnText: {
        fontSize: 14,
        fontWeight: '700',
        color: '#fff',
    },

    /* ── N/A Card ── */
    naCard: {
        borderWidth: 2,
        borderColor: '#EF4444',
        borderRadius: 10,
        padding: 12,
        marginTop: 16,
        alignItems: 'center',
    },
    naText: {
        fontSize: 13,
        fontWeight: '600',
        color: '#374151',
        textAlign: 'center',
    },

    /* ── Checkout Card ── */
    checkoutCard: {
        width: '70%',
        marginTop: 20,
        padding: 24,
        backgroundColor: '#fff',
        borderRadius: 14,
        ...SHADOWS.md,
        alignSelf: 'center',
    },
    checkoutTitle: {
        fontSize: 22,
        fontWeight: '700',
        color: '#6C2BD9',
        marginBottom: 20,
    },
    checkoutSummary: {
        borderRadius: 10,
        borderColor: '#E5E7EB',
        borderWidth: 1,
        marginBottom: 24,
        padding: 20,
    },
    checkoutSummaryRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    checkoutItemName: {
        fontSize: 14,
        fontWeight: '500',
        color: '#111827',
    },
    checkoutItemPrice: {
        fontSize: 15,
        fontWeight: '700',
        color: '#6C2BD9',
    },
    checkoutDivider: {
        height: 1,
        backgroundColor: '#E5E7EB',
        marginVertical: 16,
    },
    checkoutTotal: {
        fontSize: 18,
        fontWeight: '700',
        color: '#6C2BD9',
    },

    /* ── Result Card (Success / Failure) ── */
    resultCard: {
        width: '60%',
        marginTop: 20,
        padding: 30,
        backgroundColor: '#fff',
        borderRadius: 14,
        alignSelf: 'center',
        alignItems: 'center',
        ...SHADOWS.md,
    },
    resultIconWrap: {
        width: 80,
        height: 80,
        borderRadius: 40,
        backgroundColor: '#D1FAE5',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
    },
    resultTitle: {
        fontSize: 22,
        fontWeight: '700',
        color: '#111827',
        marginBottom: 12,
        textAlign: 'center',
    },
    resultDivider: {
        width: 60,
        height: 3,
        borderRadius: 2,
        backgroundColor: '#6C2BD9',
        marginBottom: 20,
    },
    continueBtn: {
        flexDirection: 'row',
        backgroundColor: '#6C2BD9',
        borderRadius: 10,
        paddingHorizontal: 24,
        paddingVertical: 12,
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: 20,
    },
    continueBtnText: {
        fontSize: 16,
        fontWeight: '700',
        color: '#fff',
    },
    resultMessage: {
        fontSize: 14,
        color: '#6B7280',
        textAlign: 'center',
        lineHeight: 21,
    },
});

export default drawerHoc({
    Component: CommanBuyCertificate,
    showBackButton: true,
    noScroll: true,
});
